module.exports = __webpack_public_path__ + "static/roving_harper_mtg_clb-9f33f81bed8f8e7107dab786b2269c86.webp";